import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSetRecoilState } from "recoil";
import getSchema from "../../lib/api/getSchema";
import MomSysMstMaterialFileCreateButton from "../input/MomSysMstMaterialFileCreateButton";
import MomSysMstMaterialFileDeleteButton from "../input/MomSysMstMaterialFileDeleteButton";
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
import BasicCrudScreenActionItemLayout from "../screenTypes/layout/BasicCrudScreenActionItemLayout";

import AccessControl from "../functional/AccessControl";
import notificationState from "../../states/notificationState";

function MomSysMstMaterialFile(props) {
    const { id, selectMstGrid } = props;

    const [schema, setSchema] = useState();
    const [api, setApi] = useState();
    const [grid, setGrid] = useState();
    const [selectFile, setSelectFile] = useState();
    const [isEmpty, setIsEmpty] = useState();

    const setNotification = useSetRecoilState(notificationState);

    const { t } = useTranslation();

    useEffect(() => {
        let mounted = true;

        async function schemaSetting() {
            let schema = await getSchema("MomSysMstMaterialFile");

            if ( mounted ) {
                setSchema(schema);
            }
        }

        schemaSetting();

        return (() => {
            mounted = false;
        });
    }, []);

    useEffect(() => {
        if(api) {
            api.refresh();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectMstGrid]);
    
    useEffect(() => {
        (async () => {
            if (grid) {
                grid.selectionChanged.addHandler((grid, event) => {
                    if (grid.selectedItems && grid.selectedItems[0]) {
                        setSelectFile(grid.selectedItems[0]);
                    }
                });

                grid.itemsSourceChanged.addHandler((grid, event) => {
                    if (grid.selectedItems && grid.selectedItems[0]) {
                        setSelectFile(grid.selectedItems[0]);
                    }
                });
            }
        })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [grid]);
    
    const onApiInitialized = (api) => {
        setApi(api);
    };

    const onInitialized = (grid) => {
        setGrid(grid);
    };

    const notifySuccess = (msg) => {
        setNotification({
            severity: "success",
            msg: msg,
            open: true,
        });
    };

    const notifyFailure = (msg) => {
        setNotification({
            severity: "error",
            msg: msg,
            open: true,
        });
    };

    const onSuccess = (msg) => {
        notifySuccess(msg);
        if(api) {
            api.refresh();
        };
    };

    const onFailure = (reason) => {
        notifyFailure(reason.response ? reason.response.data : reason);
    };

    const notifyWarning = (msg) => {
        setNotification({
            severity: "warning",
            msg: msg,
            open: true,
        });
    };

    const onNotifyWarning = (msg) => {
        notifyWarning(msg);
    };

    const onLoadData = (data) => {
        setIsEmpty(data.length < 1 ? true : false)
    }

    const onModifyUrl = (url) => {
        return `api/MomSysMstMaterialFile/${selectMstGrid.materialCode}/${selectMstGrid.materialCodeVer}`;
    };

    return (
        <>
            <BasicCrudScreenType
                id={id}
                table="MomSysMstMaterialFile"
                view="MomSysVwMstMaterialFile"
                onApiInitialized={onApiInitialized}
                onInitialized={onInitialized}
                onModifyViewUrl={(url) => onModifyUrl(url)}
                headerTitle={t("term.standardFile")}
                onLoadData={onLoadData}
                noCreate
                noEdit
                noDelete
                noExcel
                noFilter
                onAppendButtonInFrontOfSearch={() => (
                    <>
                        <BasicCrudScreenActionItemLayout>
                            <AccessControl accessTarget={schema && schema.name} accessMethod="POST">
                                <MomSysMstMaterialFileCreateButton
                                    id="MomSysMstMaterialFileCreateButton"
                                    schema={schema}
                                    refresh={api}
                                    selectMstGrid={selectMstGrid}
                                    onSuccess={onSuccess}
                                    disabled={selectMstGrid.materialCode? false : true}
                                />
                            </AccessControl>

                            <AccessControl accessTarget={schema && schema.name} accessMethod="DELETE">
                                <MomSysMstMaterialFileDeleteButton
                                    id="MomSysMstMaterialFileDeleteButton"
                                    schema={schema}
                                    grid={grid}
                                    refresh={api}
                                    color="secondary"
                                    onSuccess={onSuccess}
                                    onFailure={onFailure}
                                    onPartialFailure={onNotifyWarning}
                                    disabled={isEmpty ? true : false}
                                />
                            </AccessControl>
                        </BasicCrudScreenActionItemLayout>
                    </>
                )}
            />
        </>
    );
}

export default MomSysMstMaterialFile;
